import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { CARETEAM } from '../../shared/Strings';

function CareTeamComposnent(props) {
  return (
    <div>
      <Box
        sx={{
          mt: 3,
        }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '19px',
          }}>
          {CARETEAM.ASSOCIATE_CARE_PLANS}
        </Typography>
        {/* To be wrapped in loop */}
        <Box
          sx={{
            border: ' 1px solid #E4E4E4',
            borderRadius: ' 8px',
            mt: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              padding: 2,
            }}>
            <Box
              component="img"
              height="32px"
              width="32px"
              src={props.icon}
              alt={props.category}
              sx={{ mr: 2 }}
            />
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: ' 16px',
                lineHeight: '24px',
              }}>
              {CARETEAM.OBESITY_NARRATIVE}
            </Typography>
            <Box sx={{ position: 'absolute', right: '40px' }}>
              <Button
                uppercase={false}
                variant="text"
                sx={{ color: ' #036FCB' }}>
                {CARETEAM.VIEW_DETAILS}
              </Button>
            </Box>
          </Box>
          <Box sx={{ ml: 2 }}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                color: '#666666',
              }}>
              {CARETEAM.INTERVENTIONS}
            </Typography>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                padding: '5px',
              }}>
              <ul>
                <li>Daily excercise for 30 mins</li>
                <li>Daily excercise for 30 mins</li>
                <li>
                  Services are provided at home because the services are
                  medically necessary to properly attend the member
                </li>
              </ul>
            </Typography>
            {/* <ReadMoreReadLessComponent text={text} /> */}
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default CareTeamComposnent;
